const space = '\u00A0';

const SYMBOLS = {
    SPACE: space,
};

export default SYMBOLS;
